import React, {useEffect, useState} from 'react';
import {useHistory} from 'react-router-dom';
import {apiFarmerLinkedAccounts, apiGetUser} from 'constants/Api';
import WalletCard from './WalletCard';

interface WalletListProps {
  customerUserId: string;
}

function WalletList({customerUserId}: WalletListProps) {
  const [loading, setLoading] = useState(true);
  const [wallets, setWallets] = useState<any[]>([]);
  const history = useHistory();

  useEffect(() => {
    let isMounted = true;
    setLoading(true);

    // 1. Fetch the user => get farmerId => fetch linked accounts
    apiGetUser(customerUserId)
      .then((fetchedUser) => {
        const farmerId = fetchedUser?.farmer?.id;
        if (!farmerId) {
          throw new Error('No farmerId found for this user');
        }
        return apiFarmerLinkedAccounts(String(farmerId));
      })
      .then((accounts) => {
        if (!isMounted) return;

        const newWallets: any[] = [];
        console.log('accounts', accounts);

        // 2. For each "acc" => store company logo as well
        accounts.forEach((acc: any) => {
          const companyLogo = acc.company?.image; // e.g. "https://..."
          if (acc?.accounts?.length > 0) {
            acc.accounts.forEach((sub: any) => {
              newWallets.push({
                id: acc.id,
                name:
                  sub.accountName ||
                  sub.accountNumber ||
                  acc.customName ||
                  'Wallet',
                accountNumber: sub.accountNumber,
                balance: sub.AvailableBalance,
                logo: companyLogo, // Store the company logo from acc.company.image
              });
            });
          }
        });

        setWallets(newWallets);
      })
      .catch((err) => console.error('Error fetching wallets', err))
      .finally(() => {
        if (isMounted) setLoading(false);
      });

    return () => {
      isMounted = false;
    };
  }, [customerUserId]);

  if (loading) {
    return <div>Loading wallets ...</div>;
  }
  if (!wallets.length) {
    return <div>No wallets found</div>;
  }

  return (
    <div className="wallet-list">
      {wallets.map((wallet, idx) => (
        <WalletCard
          key={idx}
          wallet={wallet}
          onClick={() => {
            history.push({
              pathname: `/customers/dashboard/${customerUserId}/wallets/${wallet.id}`,
              state: {
                wallets, // pass the entire array
                selectedWalletId: wallet.id,
              },
            });
          }}
        />
      ))}
    </div>
  );
}

export default WalletList;
